//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import EventBus from "@/event-bus.js";
import { FIND_TIPOS_ENCUESTA } from "@/graphql/queries/encuestas.js";
import { contextualHelp } from "@/utils/contextualHelp.js";

export default {
  name: "EncuestasTipoList",
  apollo: {
    tiposEncuesta: {
      query: FIND_TIPOS_ENCUESTA,
      update(data) {
        return data.findTiposEncuesta;
      }
    }
  },
  async mounted() {
    EventBus.$emit("page-loaded", { page: "MisEncuestasList" });
    EventBus.$emit("dynamic-help", {
      help: contextualHelp["MisEncuestasList"]
    });
  },
  data() {
    return {
      encuestas: [],
      columns: [
        {
          name: "descripcion",
          label: "Tipo Encuesta",
          align: "left",
          field: "descripcion"
        },
        {
          name: "options",
          label: ""
        }
      ],
      medicos: [],
      tiposEncuesta: [],
      medicoSelected: null,
      encuestaSelected: null
    };
  },
  methods: {
    readEncuesta(row) {
      this.$router.push({
        path: `/encuestas-tipo/${row.id}`,
        query: { readOnly: true }
      });
      return;
    },
    showBottomSheet(evt, row) {
      if (this.$q.screen.lt.md) {
        this.$q
          .bottomSheet({
            message: "Seleccione una acción: ",
            grid: false,
            actions: [
              {
                label: "Ver encuesta",
                icon: "visibility",
                id: "visible",
                classes: "custom-color-sheet"
              }
            ]
          })
          .onOk(action => {
            switch (action.id) {
              case "visible":
                this.readEncuesta(row);
                break;
            }
          });
      }
    }
  }
};
